import { render } from "./tableColumnOrder.vue?vue&type=template&id=77f6476a&scoped=true"
import script from "./tableColumnOrder.vue?vue&type=script&lang=js"
export * from "./tableColumnOrder.vue?vue&type=script&lang=js"

import "./tableColumnOrder.vue?vue&type=style&index=0&id=77f6476a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f6476a"]])

export default __exports__